import React from 'react';
import { cn } from '@/lib/utils';

interface RecipientSentBadgeProps {
  alreadySent: boolean;
}

export const RecipientSentBadge: React.FC<RecipientSentBadgeProps> = ({ alreadySent }) => (
  <span
    className={cn(
      'inline-flex h-5 items-center justify-center gap-1 rounded-lg px-2 py-0.5 text-xs font-semibold leading-4 whitespace-nowrap',
      alreadySent
        ? 'border border-gray-200 bg-white text-gray-700'
        : 'bg-[#DC2626] text-white'
    )}
  >
    {alreadySent ? 'Sim' : 'Não'}
  </span>
);
